<template>
  <l-marker
    v-if="markerIcon&&show"
    :lat-lng="markerPosition"
    :icon="markerIcon"
  >
    <l-tooltip>{{ bezeichnung }}</l-tooltip>
  </l-marker>
</template>

<script>
import { LMarker, LTooltip } from "@vue-leaflet/vue-leaflet";
import L from "leaflet";

export default {
  name: "Feuerwache",
  components: { LMarker, LTooltip },
  props: {
    bezeichnung: String,
    aktiveFeuerwehr: Boolean,
    zoom: Number,
    markerPosition: Array,
  },
  watch: {
    zoom(newZoom) {
      if(!this.$props.aktiveFeuerwehr&&newZoom < 14){
        this.show = false;
      } else if(this.$props.aktiveFeuerwehr){
        this.show = true;
      } else {
        this.show = true;
      }
    }
  },
  data() {
    return {
      baseIconSize: 40, // Pixel bei Zoom 18
      markerIcon: L.icon({
        iconUrl: require("@/assets/KartenIcons/Feuerwache.png"),
        iconSize: [40, 40],
        iconAnchor: [20, 40],
        popupAnchor: [0, -20],
        tooltipAnchor: [0, -40]
      }),
      show: true
    };
  },
  methods: {
    createIcon(zoom) {
      const size = this.baseIconSize * Math.pow(2, (zoom - 18) * 0.5);
      return L.icon({
        iconUrl: require("@/assets/KartenIcons/Feuerwache.png"),
        iconSize: [size, size],
        iconAnchor: [size / 2, size],
        popupAnchor: [0, -size / 2],
        tooltipAnchor: [0, -size]
      });
    },
    onMapReady(map) {
      this.mapObject = map;
      map.invalidateSize();
    },
  },
  created() {
    this.markerIcon = this.createIcon(18);
  },
  mounted() {

  }
};
</script>

<style scoped>
.markerIcon{
    max-height: 2.5rem !important;
    filter: drop-shadow(0 0 0.05rem rgb(53, 53, 53));
}
</style>